
export function isButtonContent(contentInstance: any) {
  return contentInstance.templateType === 'concierge-card-buttons';
}

// https://api.development.flybits.com/kernel/content/instances/E351203A-1D73-4E48-BE19-07D95008CD4B
export function getButtonTexts(contentInstance: any) {
  return contentInstance.content.data[0].buttons.map((button: any) => button.localizations.en.text);
}
